<template>
  <div class="oficina-monitoramento-avaliacao-app">
    <!-- Tela de Configuração -->
    <SettingsScreen
      v-if="showSettings"
      :config="config"
      @start-presentation="handleStartPresentation"
      @update-config="updateConfig"
    />

    <!-- Tela Principal de Apresentação -->
    <PresentationScreen
      v-else
      :config="config"
      :current-step-index="currentStepIndex"
      :is-presentation-mode="isPresentationMode"
      @go-to-settings="showSettings = true"
      @update-step="currentStepIndex = $event"
    />
  </div>
</template>

<script>
import SettingsScreen from './components/SettingsScreen.vue'
import PresentationScreen from './components/PresentationScreen.vue'
import ArquivosService from '@/services/Arquivos.js'

export default {
  name: 'OficinaMonitoramenteAvaliacao',
  components: {
    SettingsScreen,
    PresentationScreen,
  },
  metaInfo: {
    title: 'Oficina e monitoramento',
    titleTemplate: null,
  },
  data() {
    return {
      showSettings: true,
      currentStepIndex: 0,
      backUrl: '/dashboard',
      showHeader: true,
      isPresentationMode: false,
      config: {
        state: '',
        city: '',
        facilitatorName: '',
        facilitatorPhoto: ArquivosService.obterAvatarPadrao(),
        facilitatorBio:
          'Especialista em Saúde Pública com foco em Monitoramento e Avaliação.',
        contactName: '',
        theme: 'Oficina de Monitoramento e Avaliação',
        whatsappNumber: '5583996801291',
        evaluationLink: 'https://esusfeedback.com.br/avaliacao-treinamento',
        platform: 'Google Meet',
        sosLink: 'https://sos.splashtop.com',
      },
    }
  },
  created() {
    // Carregar dados do usuário ANTES do primeiro render
    this.loadUserSession()

    this.loadUrlParams()

    // Forçar atualização do objeto para garantir reatividade em todos os casos
    this.config = { ...this.config }
  },
  mounted() {
    // Verificar se está na rota de apresentação
    if (this.$route.path === '/oficina-monitoramento-avaliacao/apresentacao') {
      this.showSettings = false
      this.showHeader = false // Esconder header na apresentação
      this.isPresentationMode = true // Modo apresentação
      // Quando estiver na apresentação, voltar deve ir para a página de configuração
      this.backUrl = '/oficina-monitoramento-avaliacao'
    } else {
      // Na tela de configuração, voltar vai para o dashboard
      this.showSettings = true
      this.showHeader = true
      this.backUrl = '/dashboard'
      this.isPresentationMode = false
    }
  },
  watch: {
    $route() {
      // Atualizar config e modo de tela sempre que a rota mudar
      this.loadUrlParams()

      if (
        this.$route.path === '/oficina-monitoramento-avaliacao/apresentacao'
      ) {
        this.showSettings = false
        this.showHeader = false
        this.isPresentationMode = true
        this.backUrl = '/oficina-monitoramento-avaliacao'
      } else {
        this.showSettings = true
        this.showHeader = true
        this.isPresentationMode = false
        this.backUrl = '/dashboard'
      }
    },
  },
  methods: {
    loadUserSession() {
      // Buscar dados do usuário logad
      if (this.$store.state.username) {
        this.config.facilitatorName = this.$store.state.username
      }

      // Carrega a foto do facilitador pelo serviço autenticado
      this.carregarFotoFacilitador()

      // Buscar cidade do store
      let cidadeCompleta = ''
      if (this.$store.state.cidade) {
        cidadeCompleta = this.$store.state.cidade

        // Tentar extrair estado do nome da cidade se estiver no formato "CIDADE - UF"
        const cidadeParts = cidadeCompleta.split(' - ')
        if (cidadeParts.length >= 2) {
          // O último elemento após " - " geralmente é o estado
          const possivelEstado = cidadeParts[cidadeParts.length - 1].trim()

          // Verificar se é uma UF válida (2 letras maiúsculas)
          if (
            possivelEstado.length === 2 &&
            possivelEstado === possivelEstado.toUpperCase()
          ) {
            this.config.state = possivelEstado
            // Remover o estado do nome da cidade
            this.config.city = cidadeParts.slice(0, -1).join(' - ').trim()
          } else {
            // Se não conseguir extrair, usar a cidade completa
            this.config.city = cidadeCompleta
          }
        } else {
          // Se não tiver o formato "CIDADE - UF", usar a cidade completa
          this.config.city = cidadeCompleta
        }
      }

      // Se ainda não tiver estado, tentar obter a partir do código IBGE (dois primeiros dígitos)
      if (!this.config.state && this.$store.state.cod_ibge) {
        const codIbge = String(this.$store.state.cod_ibge)
        // Os dois primeiros dígitos do código IBGE representam o estado
        const ufCode = codIbge.substring(0, 2)

        // Mapear código do estado para UF
        const estadoMap = {
          11: 'RO',
          12: 'AC',
          13: 'AM',
          14: 'RR',
          15: 'PA',
          16: 'AP',
          17: 'TO',
          21: 'MA',
          22: 'PI',
          23: 'CE',
          24: 'RN',
          25: 'PB',
          26: 'PE',
          27: 'AL',
          28: 'SE',
          29: 'BA',
          31: 'MG',
          32: 'ES',
          33: 'RJ',
          35: 'SP',
          41: 'PR',
          42: 'SC',
          43: 'RS',
          50: 'MS',
          51: 'MT',
          52: 'GO',
          53: 'DF',
        }

        const uf = estadoMap[ufCode]
        if (uf) {
          this.config.state = uf
        }
      }

      this.config = { ...this.config }
    },
    loadUrlParams() {
      const query = this.$route.query
      const estado = query.estado || query.state
      const cidade = query.cidade || query.city

      if (estado) this.config.state = estado
      if (cidade) this.config.city = cidade

      if (query.theme) {
        this.config.theme = query.theme
      }

      // Se estiver na rota de apresentação ou houver parâmetros de apresentação, ir direto para apresentação
      if (
        this.$route.path === '/oficina-monitoramento-avaliacao/apresentacao' ||
        query.facilitatorName ||
        query.platform
      ) {
        this.showSettings = false
        this.showHeader = false
        this.isPresentationMode = true
        // Quando estiver na apresentação, voltar deve ir para a página de configuração
        this.backUrl = '/oficina-monitoramento-avaliacao'
        this.config = {
          ...this.config,
          state: query.state || estado || '',
          city: query.city || cidade || '',
          facilitatorName: query.facilitatorName || this.config.facilitatorName,
          facilitatorPhoto:
            query.facilitatorPhoto || this.config.facilitatorPhoto,
          contactName: query.contactName || '',
          theme: query.theme || this.config.theme,
          whatsappNumber: query.whatsappNumber || this.config.whatsappNumber,
          evaluationLink: query.evaluationLink || this.config.evaluationLink,
          platform: query.platform || this.config.platform,
          sosLink: query.sosLink || this.config.sosLink,
        }
      }
    },
    updateConfig(newConfig) {
      this.config = { ...this.config, ...newConfig }
    },
    handleStartPresentation() {
      this.$router.push({
        path: '/oficina-monitoramento-avaliacao/apresentacao',
        query: {
          state: this.config.state,
          city: this.config.city,
          facilitatorName: this.config.facilitatorName,
          contactName: this.config.contactName,
          theme: this.config.theme,
          whatsappNumber: this.config.whatsappNumber,
          evaluationLink: this.config.evaluationLink,
          platform: this.config.platform,
          sosLink: this.config.sosLink,
        },
      })
    },

    /**
     * Carrega a foto do facilitador utilizando o cache compartilhado.
     *
     * @returns {Promise<void>}
     */
    async carregarFotoFacilitador() {
      const { cod_ibge, id } = this.$store.state

      if (!cod_ibge || !id) {
        return
      }

      try {
        const url = await ArquivosService.obterFotoPerfil(cod_ibge, id)

        if (this._isDestroyed || this._isBeingDestroyed) {
          return
        }

        if (url) {
          this.config.facilitatorPhoto = url
        }
      } catch (error) {
        console.error('Erro ao carregar foto do facilitador:', error)
      }
    },
  },
}
</script>

<style scoped>
.oficina-monitoramento-avaliacao-app {
  min-height: 60vh;
  padding: 12px 30px;
}

@media (max-width: 992px) {
  .oficina-monitoramento-avaliacao-app {
    padding: 24px 24px;
  }
}

@media (max-width: 576px) {
  .oficina-monitoramento-avaliacao-app {
    padding: 16px 12px;
  }
}
</style>

<style>
@import './styles.css';
</style>
